// Efecto "vidrio líquido" (glassmorphism) reutilizable para cards de dashboards.
// Se pasa como className a <Card>; gracias a tailwind-merge sobreescribe el bg/borde
// sólidos del Card base por una superficie translúcida con desenfoque.
export const GLASS =
  'border-white/40 bg-white/40 ring-1 ring-inset ring-white/40 backdrop-blur-xl backdrop-saturate-150 ' +
  'shadow-xl shadow-black/5 hover:bg-white/50 ' +
  'dark:border-white/10 dark:bg-white/[0.06] dark:ring-white/10 dark:shadow-black/30 dark:hover:bg-white/[0.09]';

// Fondo sutil para el contenedor del dashboard (da profundidad al desenfoque).
export const GLASS_BG = 'bg-gradient-to-br from-primary/10 via-transparent to-blue-500/10';
